import React, { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { toast } from "sonner";
import { ArrowLeft } from "lucide-react";

const ForgotPasswordModal = ({ isOpen, onClose }) => {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const handleSubmit = () => {
    if (!email || !email.includes("@")) {
      toast.error("Por favor ingresa un correo válido");
      return;
    }

    // Crear el mensaje de WhatsApp
    const whatsappPhone = "52425434"; // Número configurado
    const message = `Hola, quisiera recuperar mi contraseña de FastCopy.\n\nMi correo es: ${email}\n\nPor favor, ayúdame a resetear mi contraseña.`;
    
    // Codificar el mensaje para la URL
    const encodedMessage = encodeURIComponent(message);
    
    // Crear el link de WhatsApp Web (wa.me)
    const whatsappUrl = `https://wa.me/${whatsappPhone}?text=${encodedMessage}`;
    
    // Abrir WhatsApp en una nueva pestaña
    window.open(whatsappUrl, "_blank");
    
    toast.success("Se abrió WhatsApp. Envía el mensaje para recuperar tu contraseña.");
    setSubmitted(true);
    
    // Cerrar modal después de 2 segundos
    setTimeout(() => {
      handleClose();
    }, 2000);
  };

  const handleClose = () => {
    setEmail("");
    setSubmitted(false);
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="bg-slate-900 border-white/10 text-white max-w-sm">
        <DialogHeader>
          <DialogTitle className="text-2xl font-bold text-center">
            {submitted ? "¡Abre WhatsApp!" : "Recuperar Contraseña"}
          </DialogTitle>
        </DialogHeader>

        {!submitted ? (
          <div className="space-y-4 mt-4">
            <p className="text-sm text-white/70 text-center">
              Ingresa tu correo y se abrirá WhatsApp para contactarnos
            </p>
            <Input
              type="email"
              placeholder="Correo electrónico"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={(e) => e.key === 'Enter' && handleSubmit()}
              className="bg-white/5 border-white/10 text-white"
            />
            <Button
              onClick={handleSubmit}
              className="w-full bg-gradient-to-r from-green-500 to-emerald-500 hover:from-green-600 hover:to-emerald-600"
            >
              Abrir WhatsApp
            </Button>
            <button
              onClick={handleClose}
              className="w-full flex items-center justify-center gap-2 text-white/70 hover:text-white text-sm transition-colors"
            >
              <ArrowLeft className="w-4 h-4" />
              Volver
            </button>
          </div>
        ) : (
          <div className="space-y-4 mt-4 text-center">
            <p className="text-sm text-white/70">
              Se ha abierto WhatsApp. Envía el mensaje con tu correo y nos contactaremos para ayudarte a recuperar tu contraseña.
            </p>
            <p className="text-xs text-white/50">
              Este diálogo se cerrará automáticamente en unos segundos...
            </p>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};

export default ForgotPasswordModal;
